import PropTypes from 'prop-types';
import { AccountBalanceOutlined, DeleteOutlined, Edit } from '@mui/icons-material';
import IconButton from '@mui/material/IconButton';

import { ListItemWrapper } from 'components/ui';

import * as Styled from './ListItem.styles';
import { useGetBankAccountData } from 'api';
import React, { useMemo } from 'react';
import get from 'lodash/get';

export const ListItem = ({ item, onEdit, onDelete }) => {
  const { data: bankAccountData } = useGetBankAccountData(item.accountNumber, 'json');

  var bankLogo = useMemo(() => {
    const storedData = localStorage.getItem(item.accountNumber);
    const fetchedData = get(bankAccountData, 'base64Logo', '');

    if (storedData !== null && fetchedData !== '' && storedData !== fetchedData) {
      localStorage.setItem(item.accountNumber, fetchedData);
      return fetchedData;
    }

    if (storedData !== null) {
      return storedData;
    } else if (fetchedData !== '') {
      localStorage.setItem(item.accountNumber, fetchedData);
      return fetchedData;
    }

    return '';
  }, [bankAccountData]);

  return (
    <Styled.Wrapper>
      <ListItemWrapper>
        <Styled.Info>
          {bankLogo === '' ? (
            <AccountBalanceOutlined className="icon" />
          ) : (
            <Styled.BankLogo src={`data:image/jpeg;base64,${bankLogo}`} />
          )}
          <div className="info">
            <div className="name">{item.name}</div>
            <div className="description">
              {item.accountNumber} ({item.bank})
            </div>
          </div>
        </Styled.Info>
        <Styled.Actions>
          <IconButton onClick={onEdit}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={onDelete}>
            <DeleteOutlined />
          </IconButton>
        </Styled.Actions>
      </ListItemWrapper>
    </Styled.Wrapper>
  );
};

ListItem.propTypes = {
  item: PropTypes.object.isRequired,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};
